import { render, staticRenderFns } from "./currencyExplanation.vue?vue&type=template&id=0e373f4e"
import script from "./currencyExplanation.vue?vue&type=script&lang=js"
export * from "./currencyExplanation.vue?vue&type=script&lang=js"
import style0 from "./currencyExplanation.vue?vue&type=style&index=0&id=0e373f4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports